<script>
    import { createEventDispatcher } from "svelte";
    import AddMilestone from "./AddMilestone.svelte";
	import Milestone from "./Milestone.svelte";
	import { v4 as uuidv4 } from 'uuid';

	export let max_stamp_count;
    export let milestones = [
		{
			id: uuidv4(),
			stamp_count: max_stamp_count,
			type: "all",
			rewards: []
		}
	];

	const dispatch = createEventDispatcher();

	function add(e) {
		milestones.push(e.detail);
		milestones = milestones;
		dispatch("save");
	}

	function edit(e) {
		console.log(milestones);
		dispatch("save");

	}

	function remove(e) {
		console.log(e);
		milestones = milestones.filter(milestone => milestone.id !== e.detail.id);
		dispatch("save");
	}
</script>

<div class="milestones">
	{#if milestones?.length > 0}
		{#each milestones as milestone (milestone.id)}
			<Milestone bind:milestone {max_stamp_count} on:remove={(e) => {remove(e)}} on:edit={(e) => {edit( e)}}/>
		{/each}
	{:else}
		<p class="empty">Keine Meilensteine eingetragen</p>
	{/if}
	<AddMilestone {max_stamp_count} on:add={(e) => {add(e)}} />
</div>

<style>
	.milestones {
		display: flex;
		gap: 1rem;
		flex-direction: column;
	}

	.empty {
        font-style: italic;
        color: #968f89;
    }
</style>